/*!
    * @product/scmp-sdk 1.1.33
    * built by undefined
  */
import{i as t}from"./chunk-2LEANA5E.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-NP7LBMKK.js.map
